import { render } from "./OrderExecutive.vue?vue&type=template&id=1a3b122a&scoped=true"
import script from "./OrderExecutive.vue?vue&type=script&lang=js"
export * from "./OrderExecutive.vue?vue&type=script&lang=js"

import "./OrderExecutive.vue?vue&type=style&index=0&id=1a3b122a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1a3b122a"

export default script